// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__fq9vc","modal":"Modal_modal__Xhn39","slide-down":"Modal_slide-down__oI28U"};